import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { Button, Container, Grid, Link, TextField, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useContext, useEffect, useState } from "react"
import { useHistory } from 'react-router-dom'
import Utilities from '../classes/Utilities'
import Heading from '../components/Heading'
import { AppContext } from '../context/AppContextProvider'

const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    button: {
        margin: theme.spacing(1, 0, 1),
    },
}))

export default function AuthorizeDevice(props) {
    const { paths, showMessage, showError, socket } = useContext(AppContext)
    const history = useHistory()
    const [waiting, setWaiting] = useState(false)
    const [authOptions, setAuthOptions] = useState(false)
    const classes = useStyles()

    // request auth options on-mount
    useEffect(() => {
        socket
            .send('authorizeDevice', { step: 'requestOptions' })
            .then(setAuthOptions)
            .catch(showError)
    }, [setAuthOptions])

    async function handleSubmitCode(event) {
        event.preventDefault()

        setWaiting(true)

        try {
            const values = Utilities.getFormValues(event.target)

            const response = await socket.send('authorizeDevice', {
                step: 'validateCode',
                code: values.code,
            })

            showMessage(response, { variant: 'success' })
            history.goBack()

        } catch (err) {
            showError(err)
            setWaiting(false)
        }
    }

    async function handleRequestCode(method) {
        setWaiting(true)

        try {
            const response = await socket.send('authorizeDevice', {
                step: 'requestCode',
                method,
            })

            showMessage(response, { variant: 'success' })

        } catch (err) {
            showError(err)
        }

        setWaiting(false)
    }

    async function handleCancel() {
        socket.send('logout')
        history.push(paths.root)
    }

    return (
        <Container maxWidth="xs">
            <Heading icon={<LockOutlinedIcon />}>
                Authorize this Device
            </Heading>
            <form className={classes.form} onSubmit={handleSubmitCode}>
                <Typography paragraph>
                    A code has been emailed to you. Please enter it here to authorize this device:
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            id="code"
                            name="code"
                            label="Authorization Code"
                            variant="outlined"
                            required
                            fullWidth
                            disabled={waiting}
                            autoFocus
                            autoComplete="off"
                        />
                    </Grid>
                </Grid>
                <Grid container justifyContent="flex-end">
                    <Grid item>
                        <Link
                            component="button"
                            type="button"
                            variant="body2"
                            onClick={() => { handleRequestCode('email') }}
                            underline="hover"
                        >
                            Send a new code via email
                        </Link>
                    </Grid>
                </Grid>
                {authOptions.sms &&
                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <Link
                                component="button"
                                type="button"
                                variant="body2"
                                onClick={() => { handleRequestCode('sms') }}
                                underline="hover"
                            >
                                Send a new code via SMS
                            </Link>
                        </Grid>
                    </Grid>
                }
                <Button
                    className={classes.button}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={waiting}
                >
                    Authorize
                </Button>
                <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    fullWidth
                    disabled={waiting}
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
            </form>
        </Container>
    )
}
